<div class="flex flex-row gap-3 align-items-end" [formGroup]="settingsForm">
  <div>
    <label class="block font-bold mb-2" for="project">Project Name</label>
    <p-select
      inputId="project"
      [options]="projects"
      formControlName="project"
      optionLabel="name"
      optionValue="name"
      showClear="true"
      placeholder="Select a Project"
    ></p-select>
  </div>
  <div>
    <p-checkbox
      formControlName="mergeSection"
      inputId="merge"
      binary="true"
    ></p-checkbox>
    <label for="merge" class="ml-2 mb-0">Merge Section</label>
  </div>
  <div>
    <p-checkbox
      formControlName="modifySection"
      inputId="modify"
      binary="true"
    ></p-checkbox>
    <label for="modify" class="ml-2 mb-0">Modify Section</label>
  </div>
</div>
